export default "__VITE_ASSET__BAfLFl51__"